import React, { useState } from 'react';
import Axios from 'axios';
import { useAlert } from 'react-alert';
import { ModalHeader } from '../Layout/ModalElements';
import LoadingModal from '../Layout/LoadingModal.js';
import FormTextInput from '../Generic/FormTextInput';
import FormDateInput from '../Generic/FormDateInput';
import FormSelectInput from '../Generic/FormSelectInput';
import { boolAsStrSelectOptions } from '../Generic/Constants';
import Button from 'react-bootstrap/Button';

let CancelToken = Axios.CancelToken;
let source = CancelToken.source();

const EquipmentModalAdd = ({ closeModal }) => {

  const alert = useAlert();

  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    code: '-MSTD-',
    name: '',
    brand: '',  
    model: '',
    serialNumber: '',
    capacity: '',
    maxCapacity: '',
    maxCapacityUnit: '',
    maxErrAllowed: '',
    maxErrAllowedUnit: '',
    resolution: '',
    location: '',
    policy: [],
    shouldVerify: '',
    lastVerification: '',
    verificationPeriod: '',
    shouldCalibrate: '',
    lastCalibrate: '',
    calibratePeriod: '',
    calibratedBy: '',
    externalMaintenance: '',
    equipmentResponsible: 'Ricardo Briones',
    maintenancePeriod: '',
    lastMaintenance: '',
    certificates: [],
    status: 'activo'
  });

  const HandleChange = (element, value) => {
    let newState = {...form};
    newState[element] = value;
    setForm(newState);
  }

  const SaveNewRecord = () => {
    if (form.code && form.name) {

      setLoading(true);

      if (source) {
        source.cancel();
        source = CancelToken.source();
      }
  
      const opts = {
        headers: {
          'Content-Type': 'application/json'
        },
        cancelToken: source.token
      };

      const url = '/api/equipment/add';

      Axios.post(url, form, opts)
      .then((res) => {
        alert.show(res.data.msg, {type: 'success'});
      })
      .catch((err) => {
        if (Axios.isCancel(err)) {
          alert.show('Petición cancelada', {type: 'info'});
        } else if (!err.response) {
          console.log('Petición cancelada');
        } else if (err.response.status === 500) {
          alert.show('No se recibió respuesta del servidor', {type: 'error'})
        } else {
          alert.show(err.response.data.msg, {type: 'error'})
        }
      }).finally(() => setLoading(false));
    } else {
      alert.show('Complete los campos requeridos', {type: 'info'});
    }
  }

  return (
    <div className="modal-outer-container">
      <LoadingModal loading={loading}/>
      <div className="modal-inner-container">
        <ModalHeader title={'Nuevo Equipo'} closeModal={closeModal} />
        <div className="modal-form-container">
          <FormTextInput title="Código Interno Equipo" isRequired stateKey={'code'} value={form.code} handleChange={HandleChange} />
          <FormTextInput title="Nombre Equipo" isRequired stateKey={'name'} value={form.name} handleChange={HandleChange} />
          <FormTextInput title="Marca Equipo" isRequired stateKey={'brand'} value={form.brand} handleChange={HandleChange} />
          <FormTextInput title="Modelo Equipo" stateKey={'model'} value={form.model} handleChange={HandleChange} />
          <FormTextInput title="N° Serie Equipo" stateKey={'serialNumber'} value={form.serialNumber} handleChange={HandleChange} />
          <FormTextInput title="Rango o Capacidad" stateKey={'capacity'} value={form.capacity} handleChange={HandleChange} />
          <FormTextInput title="Capacidad Máxima" stateKey={'maxCapacity'} value={form.maxCapacity} handleChange={HandleChange} />
          <FormTextInput title="Capacidad Máxima (unidad de medida)" stateKey={'maxCapacityUnit'} value={form.maxCapacityUnit} handleChange={HandleChange} />
          <FormTextInput title="Error Máximo Admisible" stateKey={'maxErrAllowed'} value={form.maxErrAllowed} handleChange={HandleChange} />
          <FormTextInput title="Error Máximo Admisible (unidad de medida)" stateKey={'maxErrAllowedUnit'} value={form.maxErrAllowedUnit} handleChange={HandleChange} />
          <FormTextInput title="Resolución" stateKey={'resolution'} value={form.resolution} handleChange={HandleChange} />
          <FormTextInput title="Ubicación" stateKey={'location'} value={form.location} handleChange={HandleChange} />
          <FormSelectInput title="¿Se verifica?" stateKey={'shouldVerify'} value={form.shouldVerify} options={boolAsStrSelectOptions} handleChange={HandleChange} />
          <FormDateInput title="Fecha última verificación" stateKey={'lastVerification'} value={form.lastVerification} handleChange={HandleChange} />
          <FormTextInput title="Periodo entre verificaciones" stateKey={'verificationPeriod'} value={form.verificationPeriod} handleChange={HandleChange} />
          <FormSelectInput title="¿Se calibra?" stateKey={'shouldCalibrate'} value={form.shouldCalibrate} options={boolAsStrSelectOptions} handleChange={HandleChange} />
          <FormDateInput title="Fecha última calibración" stateKey={'lastCalibrate'} value={form.lastCalibrate} handleChange={HandleChange} />
          <FormTextInput title="Periodo entre calibraciones" stateKey={'calibratePeriod'} value={form.calibratePeriod} handleChange={HandleChange} />
          <FormTextInput title="Calibrado por" stateKey={'calibratedBy'} value={form.calibratedBy} handleChange={HandleChange} />
          <FormSelectInput title="¿Se realiza mantención externa?" stateKey={'externalMaintenance'} value={form.externalMaintenance} 
            options={boolAsStrSelectOptions} handleChange={HandleChange} />
          <FormDateInput title="Fecha última mantención" stateKey={'lastMaintenance'} value={form.lastMaintenance} handleChange={HandleChange} />
          <FormTextInput title="Periodo entre mantenciones" stateKey={'maintenancePeriod'} value={form.maintenancePeriod} handleChange={HandleChange} />
          <FormTextInput title="Responsable del equipo" stateKey={'equipmentResponsible'} value={form.equipmentResponsible} handleChange={HandleChange} />
        </div>
        <div>
          <Button className="lb-white fs-7" disabled={loading} onClick={() => SaveNewRecord()}>Guardar</Button>
        </div>
      </div>
    </div>
  )
}

export default EquipmentModalAdd;
